module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/clock_small.png?e2f3635de9d45a448e652a6c1127b3b0";